import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useContactFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      contactOwners: [],
      contactPractices: [],
      contactBusinessUnits: [],
      contactTags: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const contactSearchParamsConfig = useMemo(
    () => ({
      contactOwners: searchParamsConfig.contactOwners,
      contactPractices: searchParamsConfig.contactPractices,
      contactBusinessUnits: searchParamsConfig.contactBusinessUnits,
      contactTags: searchParamsConfig.contactTags,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback((filters) => {
    return {
      contactOwnerId: filters.contactOwners?.map((owner) => owner.id),
      contactPracticeId: filters.contactPractices?.map((practice) => practice.id),
      contactBusinessUnitId: filters.contactBusinessUnits?.map((businessUnit) => businessUnit.id),
      contactTagId: filters.contactTags?.map((tag) => tag.id),
    };
  }, []);

  return useMemo(
    () => ({ filters, searchParamsConfig: contactSearchParamsConfig, mapUrlSearchParams }),
    [filters, contactSearchParamsConfig, mapUrlSearchParams],
  );
}
